
import React, { Component } from 'react';
import { render } from 'react-dom';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Coordinates from './Coordinates';
import MeasureValues from './MeasureValues';
import { IfComp } from '../../core';
import { getExportItems } from './measureExport';

let resolve;

const MeasureInfo = ({measure}) => {
    return (
        <React.Fragment>
            <Coordinates
                coordinates={measure.values.coords}
            />
            <MeasureValues
                values={measure.values}
            />
        </React.Fragment>
    );
}

class DialogMeasureInfo extends Component {

    static create() {
        const containerElement = document.createElement('div');
        document.body.appendChild(containerElement);
        return render(<DialogMeasureInfo />, containerElement);
    }

    constructor(props) {
        super(props);
        this.state = {
            hidden: !props.show,
            measure: null,
        };
    }

    handleCancel = () => {
        this.setState({hidden: true});
        resolve(false);
    }

    render () {
        return (
            <Dialog
                hidden={this.state.hidden}
                minWidth={500}
                onDismiss={this.handleCancel}
                dialogContentProps={{
                    title: 'Detail měření',
                    type: DialogType.normal
                }}
                modalProps={{
                    isBlocking: true,
                    dragOptions: {}
                }}
                >
                {this.renderContent()}
                <DialogFooter>
                    <PrimaryButton
                        text="Export"
                        disabled={!this.state.measure}
                        menuProps={{
                            items: getExportItems(
                                this.state.measure, {
                                    exportCoordCsv: true,
                                    exportValuesCsv: true,
                                    exportMeasureJson: false
                                }
                            )
                        }}
                    />
                    <DefaultButton onClick={this.handleCancel} text="Zavřít" />
                </DialogFooter>
            </Dialog>
        );
    }

    renderContent = () => {
        return (
            <Stack>
                <IfComp cond={this.state.measure}>
                    <MeasureInfo measure={this.state.measure} />
                </IfComp>
            </Stack>
        );
    }

    show(measure) {
        this.setState({
            hidden: false,
            measure: measure
        });
        return new Promise((res) => {
            resolve = res;
        });
    }
}

export default DialogMeasureInfo.create();
